import * as React from "react";
import PageUpdater from "@vingle/wtf-sdk/components/pageUpdater";
import vingleHref from "@vingle/wtf-sdk/helpers/vingleHref";
import { VingleURL } from "@vingle/wtf-sdk/url";
import { useIntl } from "common/intl/helpers";

function DiscoverContainerHelmet({ after }: { after?: Vingle.PagingValue }) {
  const intl = useIntl();
  const metaObjects = [{ property: "og:type", content: "website" }];
  const links = [];
  if (after) {
    links.push({
      rel: "next",
      href: vingleHref(new VingleURL.Discover().toString(), {
        after: after as string,
      }),
    });
  }
  return (
    <PageUpdater
      metaObjects={metaObjects}
      link={links}
      title={intl.formatMessage({ id: "signup.discover" })}
    />
  );
}

export default React.memo(DiscoverContainerHelmet);
